"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var DocumentCardDetails_base_1 = require("./DocumentCardDetails.base");
var DocumentCardDetails_styles_1 = require("./DocumentCardDetails.styles");
exports.DocumentCardDetails = Utilities_1.styled(DocumentCardDetails_base_1.DocumentCardDetailsBase, DocumentCardDetails_styles_1.getStyles, undefined, { scope: 'DocumentCardDetails' });
//# sourceMappingURL=DocumentCardDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DocumentCard/DocumentCardDetails.js
// module id = 955
// module chunks = 0